import type { DerivedInvoiceStatus } from '../../../services/billing';

// Doctor-facing labels for the derived invoice status vocabulary — shared by
// StatusBadge (the pill) and the invoices toolbar's status filter dropdown.
// Split into its own module (rather than living in StatusBadge.tsx) because
// exporting a plain constant alongside a component trips
// react-refresh/only-export-components.
export const STATUS_LABELS: Record<DerivedInvoiceStatus, string> = {
    upcoming: 'Upcoming',
    open: 'Open',
    partial: 'Partially paid',
    paid: 'Paid',
    overdue: 'Overdue',
    void: 'Voided'
};

// Logical severity order for the Status column sort and the invoices table's
// default sort (most urgent/unpaid first): overdue -> partial -> open ->
// upcoming -> paid -> void. Matches the original mockup's ordering
// (Overdue:0, Partial:1, Open:2, Upcoming:3, Paid:4, Voided:5).
export const STATUS_PRIORITY: Record<DerivedInvoiceStatus, number> = {
    overdue: 0,
    partial: 1,
    open: 2,
    upcoming: 3,
    paid: 4,
    void: 5
};
